function setValueToSelect(node: HTMLSelectElement, value: string): void {
  for (let i = 0; i < node.options.length; i++) {
    if (node.options[i].value === value) {
      node.selectedIndex = i
      break
    }
  }
}

export default setValueToSelect
